import { useMemo } from "react";
import { AuthService } from "../services/auth.service";

export function useAuthenticatedFetch() {
  const fetchFunction = useMemo(() => {
    return async (uri: string, options: RequestInit = {}) => {
      const token = await AuthService.getShopifyToken();
      const headers: Record<string, string> = {
        ...((options.headers as Record<string, string>) || {}),
      };

      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      // Ensure specific content-type is set if not provided, for JSON requests
      if (
        !headers["Content-Type"] &&
        options.method &&
        options.method !== "GET"
      ) {
        headers["Content-Type"] = "application/json";
      }

      return fetch(uri, {
        ...options,
        headers,
      });
    };
  }, []);

  return fetchFunction;
}
